<template>
  <b-modal
    ref="modal-createcampanhalista"
    scrollable
    centered
    :hide-footer="true"
    @hide="hideModal"
    @close="hideModal"
  >
    <template #modal-title>
      Selecione qual lista de campanha deseja atribuir
    </template>

    <section>
      <label>
        <small
          v-if="form.campanhaListaId.required"
          class="text-danger"
        >*</small> Lista:</label>
      <div class="input-group">
        <b-dropdown variant="addon" no-caret>
          <template slot="button-content">
            <i class="fas fa-caret-down" />
          </template>
          <b-dropdown-item @click="onAddSegmentationModal">
            <i class="fas fa-plus text-third" /> Criar
          </b-dropdown-item>
          <b-dropdown-item
            @click="onEditSegmentationModal"
            :disabled="form.campanhaListaId.value === null"
          >
            <i class="fas fa-edit  text-third" /> Editar
          </b-dropdown-item>
        </b-dropdown>
        <b-form-select
          v-model="form.campanhaListaId.value"
          :options="form.campanhaListaId.options"
        >
          <template slot="first">
            <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
          </template>
        </b-form-select>
      </div>
    </section>

    <DefaultButton
      btnVariant="btn-third justify-content-center"
      :onClick="onSave"
      icon="fas fa-check-circle"
      text="Salvar"
    />

    <AddNewCampanhaListaModal
      ref="addSegmentationModal"
      @reload="onGetAllSegmentation"
    />
  </b-modal>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'

import ListaInteligenteRepository from '@/shared/http/repositories/configurations/listainteligente.js'
import SegmentationRepository from '@/shared/http/repositories/configurations/campaignlist.js'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import AddNewCampanhaListaModal from '@/views/private/configurations/lista-inteligente/components/add/modal/AddNewCampanhaListaModal.vue'

const AcaoListaInteligenteData = {
  campanhaListaId: null,
  acaoListaInteligente: null
}

const AcaoListaInteligenteForm = {
  campanhaListaId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  acaoListaInteligente: {
    value: null,
    defaultValue: 'CREATE_LIST_CAMPAIGN'
  }
}

export default {
  name: 'CreateCampanhaListaModal',
  mixins: [ActionsForm],
  components: {
    DefaultButton,
    AddNewCampanhaListaModal
  },
  data () {
    return {
      data: AcaoListaInteligenteData,
      form: AcaoListaInteligenteForm,
      acaoListaId: null
    }
  },
  methods: {
    showModal (acaoListaId) {
      if (acaoListaId) {
        this.acaoListaId = acaoListaId
        this.$refs['modal-createcampanhalista'].show()
        this.onGetAllSegmentation()
      }
    },
    hideModal () {
      this.$refs['modal-createcampanhalista'].hide()
    },
    onCreate () {
      loading.push()
      ListaInteligenteRepository.CreateAcao(this.acaoListaId, this.data)
        .then((response) => {
          if (response.status === 201) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
            this.$emit('reloadAcoes')
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onAddSegmentationModal () {
      this.$refs.addSegmentationModal.showModal()
    },
    onEditSegmentationModal () {
      SegmentationRepository.GetById(this.form.campanhaListaId.value)
        .then((response) => {
          const { data } = response
          this.$refs.addSegmentationModal.onEdit(data)
        })
        .catch(this.onException)
    },
    onGetAllSegmentation () {
      loading.push()
      SegmentationRepository.GetAllSortedByNome()
        .then((response) => {
          this.form.campanhaListaId.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/lista-inteligente/components/add/modal/CreateCampanhaListaModal.vue